import {useEffect, useState} from 'react';

// The value, once it has stopped changing for `delay` ms: searches run after
// the admin stops typing, not on every key.
export const useDebounced = (value, delay = 300) => {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return settled;
};
